import { gsap } from "gsap";
import { Flip } from "gsap/Flip";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin( Flip, SplitText );

let splits = [];
let tests;

function lastToFirst( elements ) {
	let last = elements[ elements.length - 1 ];
	last.parentNode.prepend( last );
}

function firstToLast( elements ) {
	let first = elements[0];
	first.parentNode.append( first );
}

function splitLines( thisTest ) {
	const thisTestPs = thisTest.querySelectorAll('blockquote p');
	const lines = SplitText.create( thisTestPs, { type: "lines" } );
	return lines;
}

window.addEventListener( 'DOMContentLoaded', event => {
  const testimonialBlock = document.querySelectorAll( '.ldlt-testimonials' );

  if ( null !== testimonialBlock ) {

    testimonialBlock.forEach( thisTestimonialBlock => {
			if ( false === thisTestimonialBlock.classList.contains( 'is-style-carousel' ) ) {
				return;
			}
			const backButton = thisTestimonialBlock.querySelector('button.prev');
			const nextButton = thisTestimonialBlock.querySelector('button.next');
			const testimonialParent = thisTestimonialBlock.querySelector('.list-testimonials');
			const testSelector = `#${thisTestimonialBlock.getAttribute('id')} .testimonial`;
			tests = gsap.utils.toArray( testSelector );
			console.log("🚀 ~ tests:", tests)

			gsap.set( tests, {
				filter: 'blur(1px)'
			});
			gsap.set( tests[1], {
				filter: 'blur(0px)',
				scale: 1.2
			});

			tests.forEach( thisTest => {
				const thisId = thisTest.getAttribute('class').match(/\d+/);
				thisTest.setAttribute( 'data-id', thisId );
				thisTest.style.display = 'flex';
				thisTest.style.opacity = 0;
				let thisSplit = splitLines( thisTest );
				
				if ( thisSplit.lines.length > 10 ) {
					// make typeface smaller, then re-split
					thisTest.classList.add('long');
					console.log("🚀 ~ thisTest.classList:", thisTest.classList)
					thisSplit = splitLines( thisTest );
					
					splits[thisId] = thisSplit.lines.slice(8);
					gsap.set( splits[thisId], {
						opacity: 0,
						rotationX: -100,
						height: 0
					});
				}
				else {
					splits[thisId] = [];
				}
				thisTest.style.display = null;
				thisTest.style.opacity = null;
			});
			
			if ( null !== nextButton ){
				nextButton.addEventListener( 'click', () => {
					tests = gsap.utils.toArray( testSelector );
					let toFocus = tests[0];
					let toFocusLines = splits[ toFocus.getAttribute('data-id') ];
					let offFocus = tests[1];
					let offFocusLines = splits[ offFocus.getAttribute('data-id') ];
					let nextTL = gsap.timeline({
						onStart: function() {
							const initState = Flip.getState( tests );
							lastToFirst( tests );
							Flip.from( initState, {
								duration: 0.3,
								ease: 'power1.inOut'
							});
						},
						duration: 0.3,
						ease: 'power1.inOut',
					});
					nextTL.to( toFocus, {
						filter: 'blur(0px)',
						duration: 0.3
					}, '<' );
					nextTL.to( offFocus, {
						filter: 'blur(1px)',
						duration: 0.3
					}, '<' );
					nextTL.to( toFocus, {
						scale: 1.2,
						duration: 0.5,
						ease: 'power1.out'
					});
					nextTL.to( offFocus, {
						scale: 1,
						duration: 0.3,
						ease: 'power1.in'
					}, '<' );
					if ( offFocusLines.length > 0 ) {
						nextTL.to( offFocusLines, {
							rotationX: -100,
							height: 0,
							opacity: 0,
							ease: 'power1.out',
							duration: 0.1,
							stagger: 0.05
						}, '<');
					}
					if( toFocusLines.length > 0 ) {
						nextTL.to( toFocusLines, {
							height: 'auto',
							rotationX: 0,
							opacity: 1,
							ease: 'power1.out',
							duration: 0.2,
							stagger: 0.05
						}, '<');
					}
				});
			}

			if ( null !== backButton ){
				backButton.addEventListener( 'click', () => {
					tests = gsap.utils.toArray( testSelector );
					let toFocus = tests[2];
					let offFocus = tests[1];
					let toFocusLines = splits[ toFocus.getAttribute('data-id') ];
					let offFocusLines = splits[ offFocus.getAttribute('data-id') ];
					let nextTL = gsap.timeline({
						onStart: function() {
							const initState = Flip.getState( tests );
							firstToLast( tests );
							Flip.from( initState, {
								duration: 0.3,
								ease: 'power1.inOut'
							});
						},
						duration: 0.3,
						ease: 'power1.inOut',
					});
					nextTL.to( toFocus, {
						filter: 'blur(0px)',
						duration: 0.3
					}, '<' );
					nextTL.to( offFocus, {
						filter: 'blur(1px)',
						duration: 0.3
					}, '<' );
					nextTL.to( toFocus, {
						scale: 1.2,
						duration: 0.5,
						ease: 'power1.out'
					});
					nextTL.to( offFocus, {
						scale: 1,
						duration: 0.3,
						ease: 'power1.in'
					}, '<' );
					if ( offFocusLines.length > 0 ) {
						nextTL.to( offFocusLines, {
							rotationX: -100,
							height: 0,
							opacity: 0,
							ease: 'power1.out',
							duration: 0.1,
							stagger: 0.05
						}, '<');
					}
					if( toFocusLines.length > 0 ) {
						nextTL.to( toFocusLines, {
							height: 'auto',
							rotationX: 0,
							opacity: 1,
							ease: 'power1.out',
							duration: 0.2,
							stagger: 0.05
						}, '<');
					}
				});
			}
  	});
	}

	window.addEventListener( 'resize', () => {
		tests.forEach( thisTest => {
			const thisId = thisTest.getAttribute('class').match(/\d+/);
			thisTest.setAttribute( 'data-id', thisId );
			thisTest.style.display = 'flex';
			thisTest.style.opacity = 0;
			let thisSplit = splitLines( thisTest );
			splits[thisId] = thisSplit.lines.slice(8);
			if ( splits[thisId].length > 0 ) {
				gsap.set( splits[thisId], {
					opacity: 0,
					rotationX: -100,
					height: 0
				});
			}
			thisTest.style.display = null;
			thisTest.style.opacity = null;
		});
	});
}, false );

